'use strict';

// Project workspace — the richest record page in the platform, refactored onto pict-section-workspace. The base
// owns the shell (header, grouped tab bar, routing, load); the ProjectWorkspaceProvider subclass keeps ALL of the
// original behavior + controllers and paints each tab by parseTemplateByHash-ing its original template (registered
// here as ExtraTemplates) into the base body, then mounting that tab's map / association editor / embeds from a
// single OnEnter (_mountTab). See [[ProjectWorkspace-Provider.js]] and [[ProjectWorkspace-Chrome.js]].

const libProjectWorkspaceProvider = require('../providers/ProjectWorkspace-Provider.js');
const { PROJECT_WORKSPACE_CSS, PROJECT_WORKSPACE_TEMPLATES } = require('../views/ProjectWorkspace-Chrome.js');

// Every leaf renders via the base `render` kind (paint its template) with the same OnEnter (mount its widgets).
const LEAF = (pKey, pLabel, pIcon) => ({ Key: pKey, Label: pLabel, Icon: pIcon, Content: { kind: 'render', ref: '_renderTabBody' }, OnEnter: (pProv) => pProv._mountTab() });

module.exports = {
	Identifier: 'ProjectWorkspace',
	Ordinal: 220,
	ProviderClass: libProjectWorkspaceProvider,
	Entity: { Name: 'Project', IDField: 'IDProject', Collection: 'Projects', GUIDField: 'GUIDProject' },
	Header:
	{
		Eyebrow: 'Project',
		Title: (pRec) => pRec.Name || `Project ${pRec.IDProject}`,
		Actions: [
			// Only people the server lets save the Project see Edit (admin, role 4 in the customer, or the creator).
			{ Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'editProject()', When: (prov) => prov.canEditProject },
			// Publishes this project's observation-type config out to the field apps (scoped sync). Headlight super-users only.
			{ Label: 'Run Config Sync', Icon: 'fas fa-cloud-arrow-up', Style: 'is-light', OnClick: 'syncConfiguration()', When: (prov) => prov.isSuperUser },
		],
		ListRoute: '#/PSRS/Project/List',
	},
	Tabs:
	[
		Object.assign(LEAF('overview', 'Overview', 'fas fa-circle-info'), { Pin: 'left' }),
		Object.assign(LEAF('location', 'Location', 'fas fa-location-dot'), { Pin: 'left' }),
		{ Key: 'contract', Label: 'Contract', Icon: 'fas fa-file-contract', Children:
			[
				LEAF('funding', 'Funding', 'fas fa-scale-balanced'),
				LEAF('changeorders', 'Change Orders', 'fas fa-file-pen'),
				LEAF('dates', 'Important Dates', 'fas fa-calendar-day'),
				LEAF('lineitems', 'Line Items', 'fas fa-list-ul'),
				LEAF('biditems', 'Bid Items', 'fas fa-gavel'),
				LEAF('bidmap', 'Bid Item Mapping', 'fas fa-right-left'),
				LEAF('organization', 'Contractors', 'fas fa-building'),
				LEAF('linecontractors', 'Line Item Contractors', 'fas fa-handshake'),
				LEAF('bidcontractors', 'Bid Item Contractors', 'fas fa-file-signature'),
			] },
		{ Key: 'materials', Label: 'Materials', Icon: 'fas fa-vials', Children:
			[
				LEAF('sampleplan', 'Sample Plan', 'fas fa-clipboard-check'),
				LEAF('sampleplandashboard', 'Sample Plan Dashboard', 'fas fa-table-list'),
			] },
		{ Key: 'connections', Label: 'Connections', Icon: 'fas fa-diagram-project', Children:
			[
				LEAF('equipment', 'Equipment', 'fas fa-truck'),
				LEAF('lab', 'Labs', 'fas fa-flask'),
				LEAF('contact', 'Personnel', 'fas fa-id-badge'),
				LEAF('staffing', 'Staffing', 'fas fa-users'),
			] },
		{ Key: 'config', Label: 'Config', Icon: 'fas fa-sliders', Children:
			[
				LEAF('branding', 'Branding', 'fas fa-image'),
				LEAF('labels', 'Labels', 'fas fa-tags'),
				LEAF('observations', 'Observation Types', 'fas fa-clipboard-check'),
			] },
		{ Key: 'data', Label: 'Data', Icon: 'fas fa-database', Pin: 'right', Children:
			[
				LEAF('data-observations', 'Observations', 'fas fa-clipboard-list'),
				LEAF('data-forms', 'Documents', 'fas fa-file-lines'),
				LEAF('data-files', 'Important Files', 'fas fa-folder-tree'),
				LEAF('data-bulk-upload', 'Bulk Upload', 'fas fa-cloud-arrow-up'),
				LEAF('data-volume', 'Data Volume', 'fas fa-chart-column'),
			] },
	],
	ExtraTemplates: PROJECT_WORKSPACE_TEMPLATES,
	CSSExtra: PROJECT_WORKSPACE_CSS,
};
